/**
 * MAS template form content. Receives all state and handlers via ctx from MAS Direct/Indirect template core hooks.
 * Uses useStore() for bidDetails and templateType.
 */
import React from 'react';
import { observer } from 'mobx-react';
import { useStore } from 'hooks/useStore';
import { ProjectInformationSection } from '../sections';

export type MASFormContentProps = {
  ctx: Record<string, any>;
};

export const MASFormContent = observer((props: MASFormContentProps) => {
  const { ctx: c } = props;
  const { BidAnalysisStore } = useStore();
  const bidDetails = BidAnalysisStore.currentBidDetails;
  const templateType = bidDetails?.template_type || 'mas';

  return (
    <>
      <div ref={el => (c.sectionRefs.current['project-details'] = el)}>
        <ProjectInformationSection
          isExpanded={c.expandedSections.projectInfo}
          onToggle={() => c.toggleSection('projectInfo')}
          templateData={c.templateData}
          formData={c.formData}
          analysisType={c.analysisType}
          gsmsHndlgType={c.gsmsHndlgType}
          supplierName={c.supplierName}
          supplierOptions={c.supplierOptions}
          contractsList={c.contractsList}
          handlingTypesList={c.handlingTypesList}
          isIndirect={c.isDirect ? false : c.isIndirect}
          pricingValidatedChecked={c.pricingValidatedChecked}
          validationErrors={c.validationErrors}
          onFieldChange={c.handleFieldChange}
          onFieldBlur={c.handleFieldBlur}
          onAnalysisTypeChange={c.setAnalysisType}
          onGsmsHndlgTypeChange={c.handleGsmsHndlgTypeChange}
          onSupplierChange={c.setSupplierName}
          isSaving={c.isSaving}
          templateType={templateType}
          onContractsChange={(selected: any, contractsData: any) => {
            c.isUpdatingContractsRef.current = true;
            const hasContracts =
              contractsData && Array.isArray(contractsData) && contractsData.length > 0;
            const contractsString = hasContracts
              ? contractsData.map((ct: any) => ct.contract_name).join(', ')
              : '';
            c.contractsExplicitlyClearedRef.current = !hasContracts;
            c.setPackSizeFormData((prev: any) => {
              const updated: any = {};
              Object.keys(prev).forEach(tabIndex => {
                const tabData = prev[parseInt(tabIndex)];
                if (tabData) {
                  const { contracts: _c3, contractsData: _cd3, ...rest } = tabData;
                  updated[parseInt(tabIndex)] = rest;
                }
              });
              return updated;
            });
            c.setFormData((prev: any) => ({
              ...prev,
              contracts: contractsString,
              contractsData: hasContracts ? contractsData : [],
            }));
            if (!hasContracts) c.setContractPriceRanking([]);
            setTimeout(() => {
              c.isUpdatingContractsRef.current = false;
            }, 3500);
          }}
          onContractsFilter={() => {
            c.isUpdatingContractsRef.current = false;
          }}
          notesCount={c.notes.filter((n: any) => n.section_name === 'manager_modification').length}
          onNotesClick={(e: React.MouseEvent<HTMLButtonElement>) =>
            c.handleNotesClick('manager_modification', e)
          }
        />
      </div>
    </>
  );
});
